import { StatusBadge } from "./StatusBadge";

export function StatCard({
  detail,
  label,
  tone,
  value,
}: {
  detail: string;
  label: string;
  tone: "critical" | "info" | "success" | "warning";
  value: string;
}) {
  return (
    <section className={`wr-stat wr-stat--${tone}`} aria-label={label}>
      <div className="wr-stat__top">
        <span className="wr-stat__label">{label}</span>
        <StatusBadge tone={tone}>{tone === "critical" ? "Watch" : "Live"}</StatusBadge>
      </div>
      <strong>{value}</strong>
      <p>{detail}</p>
      <span className="wr-stat__rail" aria-hidden />
    </section>
  );
}
